// extracted by mini-css-extract-plugin
export var body = "_dz-5";
export var closeButton = "_dz-f";
export var container = "_dz-1";
export var content = "_dz-2";
export var cta = "_dz-c";
export var ctaLabel = "_dz-b";
export var eyebrow = "_dz-3";
export var howTo = "_dz-6";
export var image = "_dz-e";
export var modal = "_dz-0";
export var socialButton = "_dz-d";
export var stepCard = "_dz-8";
export var stepLabel = "_dz-a";
export var stepNumber = "_dz-9";
export var steps = "_dz-7";
export var title = "_dz-4";